const WORDS = ["Handwoven", "Sustainable", "Made Slow", "Custom Fit", "Onam Collection"];

export default function Marquee() {
  const items = [...WORDS, ...WORDS];
  return (
    <section
      data-testid="marquee"
      className="relative overflow-hidden border-y border-white/10 bg-[#050505] py-8 md:py-12"
    >
      <div className="kln-noise" />
      <div className="kln-marquee-track">
        {items.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-6xl md:text-8xl font-light tracking-tight text-stroke-white px-8">
              {w}
            </span>
            <span className="text-[var(--kln-gold)] text-4xl md:text-6xl leading-none">
              &#10022;
            </span>
          </span>
        ))}
      </div>
    </section>
  );
}
